import React, { useState, useEffect, useContext } from 'react';
import MaterialTable from 'material-table';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { language } from 'config';
import { FirebaseContext } from 'common';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
const Withdraws = () => {
  const { api } = useContext(FirebaseContext);
  const {
    completeWithdraw
  } = api;
  const dispatch = useDispatch();
  //date constants for the date range picker
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const columns = [
    { title: 'ID', field: 'id', editable: 'never' },
    { title: language.requestDate, field: 'date', editable: 'never' },
    { title: language.driver_name, field: 'name', editable: 'never' },
    { title: language.amount, field: 'amount', editable: 'never' },
    { title: language.processed, field: 'processed', type: 'boolean', editable: 'never' },
    { title: language.processDate, field: 'procesDate', editable: 'never' },
    { title: language.bankName, field: 'bankName', editable: 'never' },
    { title: language.bankCode, field: 'bankCode', editable: 'never' },
    { title: language.bankAccount, field: 'bankAccount', editable: 'never' },
  ];
  const [data, setData] = useState([]);
  const withdrawdata = useSelector(state => state.withdrawdata);

  useEffect(() => {
    if (withdrawdata.withdraws) {
      setData(withdrawdata.withdraws.reverse());
    } else {
      setData([]);
    }
  }, [withdrawdata.withdraws]);
  //function that filters the withdraw data by the entered time range

  var resultwithdrawData = data.filter(a => {
    var date = new Date(a.date);
    return (date >= startDate && date <= endDate);
  });
  
  return (
    withdrawdata.loading ? <CircularLoading /> :
      <div>
       {/*  <MaterialTable
          title={language.booking_title}
          columns={columns}
          data={data}
          options={{
            exportButton: true
          }}
          actions={[
            rowData => ({
              icon: 'check',
              tooltip: language.process_withdraw,
              disabled: rowData.processed,
              onClick: (event, rowData) => {
                dispatch(completeWithdraw(rowData));
              }
            }),
          ]}
        /> */}
        <br />
        <br />
        <div class="container">
          <div class="row"  >
            <div class="col-sm">
              <p>Select Days</p>
            </div>
            <div class="col-sm">
              <DatePicker
                className='form-control datepicker'
                selected={startDate}
                onChange={date => setStartDate(date)}
                selectsStart
                startDate={startDate}
                id='start-date'
                endDate={endDate}
                popoverAttachment='top right'
              />
            </div>
            <div class="col-sm">
              <DatePicker
                className='form-control datepicker'
                selected={endDate}
                onChange={date => setEndDate(date)}
                selectsEnd
                startDate={startDate}
                endDate={endDate}
                minDate={startDate}
                popoverTargetAttachment='top right'
              />
            </div>
            <div class="col-sm">
            </div>
            <div class="col-sm">
            </div>
          </div>
          <MaterialTable
            title={language.booking_title}
            columns={columns}
            data={resultwithdrawData}
            style={{
              border: "2px solid gray",
              maxWidth: "1450px",
              overflow: "scroll",
              marginTop: "10px",
              marginLeft: "20px",
            }}
            options={{
              exportButton: true,
              draggable: true,
              grouping: true,
              headerStyle: {
                backgroundColor: '#144216',
                color: '#FFF'
              },
            }}
            actions={[
              rowData => ({
                icon: 'check',
                tooltip: language.process_withdraw,
                disabled: rowData.processed,
                onClick: (event, rowData) => {
                  dispatch(completeWithdraw(rowData));
                }
              }),
            ]}
          />
        </div>


      </div>
  );
}

export default Withdraws;
